var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box my-chart"},[_c('canvas',{attrs:{"id":"myChart","width":"100","height":"50"}})])}]

export { render, staticRenderFns }